export default __webpack_public_path__ + "static/media/startGameBgMb.3860757e.png";